module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAYAAABSx2cSAAABVklEQVQ4T42TTStFURSGn5ekpMhAKUaUgYGPCWUsBmYy4w8oEyVFmSgx5g9gcOUXUIipCPmYKCPdGBlgIB9bS+tqO9xzzhnu9T7rfdfZawsghNAJLAO9wIqkeTvP+hRCGAEKQFUkHpK0kwc+AXoSwl1JA3ngJ6A2IXwDaiS9pzWw2I9AfUJUBFokfWbBl0BHJDoHxiVd5Im9bmIXmlOdpOcs0OoWewzYiMQW9y4vbPPeA9UOzEtayAX7ksTRH4C2PNHlsN3zsY3hjouS5rLcS2Jb0S1g1IFXWxxJ16lXVSqGEFqBq2j2I6A/bVF+nD3+DLAUua1KmvRaBWAGt5I+vq8qjhVCqAQOzTE6XwP2gVmgHTgFhiUVf8Hu0ARY5OaUec+Avj+wN+gC9oCGlAbT/8LeoBvYBhrLNCiUhb2BRd9M/AMrvQCDqbA3MI09nAl/fQfAlKSbL2Zsc2ViteK8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/tel.png
// module id = 0mBB
// module chunks = 0